<template>
  <div class="item-not-found">
    <div class="item-not-found-wrapper">
      <span class="item-not-found-title">
        {{ translate('itemNotFound') }}
      </span>
      <span class="item-not-found-message">
        {{ translate('urlDoesntLeadAnywhere') }}
      </span>
      <span class="item-not-found-message">
        {{ translate('itemMightBeDeleted') }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ItemNotFound',

  data() {
    return {
      listenersAdded: false,
    };
  },

  activated() {
    this.addEventListeners();
  },
  deactivated() {
    this.removeEventListeners();
  },

  mounted() {
    this.addEventListeners();
  },

  methods: {
    close() {
      this.$store.dispatch('itemNotFound', false);
    },

    addEventListeners() {
      if (this.listenersAdded) return;
      window.addEventListener('popstate', this.close);
      this.listenersAdded = true;
    },

    removeEventListeners() {
      if (!this.listenersAdded) return;
      window.removeEventListener('popstate', this.close);
      this.listenersAdded = false;
    },
  },
};
</script>
<style lang="scss">
.item-not-found {
  @apply flex
  flex-col
  justify-center
  items-center
  text-center
  bg-background-strongest
  absolute
  top-0
  right-0
  left-0
  bottom-0
  z-[5];
  max-height: 100vh;

  .item-not-found-wrapper {
    @apply flex
    flex-col
    justify-center
    items-center
    p-8
    border-standard-border border border-solid rounded-lg;
    background-color: var(--importantEl);

    .item-not-found-title {
      @apply text-text-default
    text-xl
    font-medium;
    }

    .item-not-found-message {
      @apply text-text-default
    text-sm
    font-normal;
    }

    .item-not-found-message:nth-of-type(2) {
      @apply mt-4 mb-4;
    }
    .item-not-found-message:nth-of-type(3) {
      @apply text-text-placeholder;
    }
  }
}
</style>
